export default __webpack_public_path__ + "static/media/img2.7fa373d7.jpg";